/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CategoriaForm } from './categoria-form';


export interface ServizioMensaPastiDipendentiUpsertForm { 
    numero_pasti_totale_docenti?: number;
    numero_pasti_totale_personale_ata?: number;
    numero_pasti_totale_personale_tecnico?: number;
    numero_pasti_totale_collaboratori?: number;
    categorie?: Array<CategoriaForm>;
}

